import _ from 'lodash';

import * as types from '_/vuex/mutation-types';

const photonConfig = require('~/config/config.json');

import Vue from 'vue';

/**
 * Define the module state
 *
 * @type  {object}
 */
const state = {
    entries: {},
    entriesPagination: {},
    payload: {
        filter: {
            comment_publish_date_end: moment().format(),
            comment_publish_date_start: moment().startOf('day').format(),
            comment_status: 'pending',
            title: '',
        },
        include_relations: true,
        pagination: {
            current_page: 1,
            items_per_page: photonConfig.searchItemsPerPage,
        },
    },
};

/**
 * Sets a nested state object value
 */
const _setNestedObjectValue = (state, objectReference, path, value) => {
    const objectPath = path.split('.');
    const valueKey = objectPath.pop();
    let currentObjectReference = objectReference;

    objectPath.forEach(function (elem) {
        if (Object.prototype.toString.call(currentObjectReference[elem]) !== '[object Object]') {
            Vue.set(currentObjectReference, elem, {});
        }
        currentObjectReference = currentObjectReference[elem];
    }, 'payload');

    Vue.set(currentObjectReference, valueKey, value);
};

/**
 * Unsets a nested state object value
 */
const _unsetNestedObjectValue = (state, objectReference, path) => {
    if (_.has(objectReference, path)) {
        _.unset(objectReference, path);
    }
    const objectPath = path.split('.');
    objectPath.pop();
    _removeEmptyObjectsFromNestedObject(state, objectReference, objectPath);
};

/**
 * Removes empty state objects from nested state object
 */
const _removeEmptyObjectsFromNestedObject = (state, objectReference, objectPath) => {
    if (objectPath.length == 1 && objectPath[0] == 'filter') {
        return;
    }
    const valueKey = objectPath.pop();
    let currentObjectReference = objectReference;

    objectPath.forEach(function (elem) {
        currentObjectReference = currentObjectReference[elem];
    });

    if (_.isObject(currentObjectReference)
        && _.isObject(currentObjectReference[valueKey])
        && _.isEmpty(currentObjectReference[valueKey])) {
        Vue.delete(currentObjectReference, valueKey);
        _removeEmptyObjectsFromNestedObject(state, objectReference, objectPath);
    }
};

/**
 * Define the module mutations
 *
 * @type  {object}
 */
const mutations = {
    [types.CLEAR_ADVANCED_SEARCH_FILTER](state) {
        Vue.set(state.payload, 'filter', {});
    },

    [types.LOAD_DYNAMIC_MODULE_ENTRIES_PAGINATION](state, {pagination}) {
        state.entriesPagination = pagination;
    },

    [types.UPDATE_FILTERED_ENTRIES](state, {entries}) {
        state.entries = entries;
    },

    [types.UPDATE_CURRENT_PAGE_NUMBER](state, {value}) {
        state.payload.pagination.current_page = value;
    },

    [types.UPDATE_FILTER_VALUE](state, {fieldName, value}) {
        if (value !== '') {
            _setNestedObjectValue(state, state.payload, fieldName, value);
            return;
        }
        _unsetNestedObjectValue(state, state.payload, fieldName);
    },
};

/**
 * Define the module getters
 *
 * @type  {object}
 */
const getters = {
    comments: state => state
};

/**
 * Import the module actions as an object containing action methods
 *
 * @type  {object}
 */
import actions from '~/vuex/actions/commentsActions';

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};
